import type { Sequence } from "#public"

/**
 * Tests whether all elements in a sequence satisfy a predicate function.
 * Returns true if all elements pass the test, false otherwise.
 * Default predicate checks truthiness.
 *
 * @param iterable - Sequence of items to test
 * @param func - Predicate function to test each item (default: truthiness check)
 * @returns True if all items satisfy the predicate, false otherwise
 *
 * @example
 * ```ts
 * import { All } from "@pdfking/tfunc"
 *
 * All([2, 4, 6], x => x % 2 === 0) // true
 * All([1, 2, 3], x => x % 2 === 0) // false
 * All([true, 1, "yes"]) // true (all truthy)
 * All([true, 0, "yes"]) // false (0 is falsy)
 * ```
 */
export const All = <T>(iterable: Sequence<T>, func: (item: T) => boolean = a => !!a) => {
  for (const t of iterable) {
    if (!func(t)) return false
  }
  return true
}
